module.exports = __webpack_public_path__ + "img/empty-library.dd35df50.gif";